<form class="master-form" [formGroup]="composeMessageForm" enctype="multipart/form-data">
    <div class="row">


        <div class="form-group col-md-4">
            Select All
            <input type="checkbox" class="form-control" placeholder="selectAll" formControlName="selectAll"
                name="selectAll">


        </div>

        <div class="form-group col-md-10" *ngIf="this.composeMessageForm.value.selectAll==false">
            <sanabel-selectize appcode="1072" [multi]="true" formControlName="reciverSecLoginIdArray" [smallInput]="true"
                name="reciverEmpId">
            </sanabel-selectize>

            <sanabel-selectize appcode="1041" [multi]="true" formControlName="reciverGroupIdArray" [smallInput]="true"
                name="reciverEmpId">
            </sanabel-selectize>

        </div>
        <div class="form-group col-md-10">
            <label>{{ 'subject' | translate }}</label>
            <input type="text" class="form-control" placeholder="subject" formControlName="subject" name="subject">
        </div>

        <div class="form-group col-md-10">
            <label>{{ 'MESSAGE' | translate }}</label>
            <textarea class="form-control "  formControlName="message" name="message"
                placeholder="{{'MESSAGE' | translate}}" rows="5" style="margin-bottom:10px;"></textarea>
        </div>
        <div class="form-group col-md-10">
            <div class="custom-file">
                <input type="file" class="custom-file-input"[(ngModel)]="fileName"  id="customFile" multiple (change)="onFileChange($event)">
                <label class="custom-file-label text-end text-left" for="customFile">{{filesNames}}</label>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <btns-ctrl #btnCtrl1 [appCodes]="[6623]" [disabled]="composeMessageForm.invalid"
                (clicked)="onClicked($event)"></btns-ctrl>
        </div>
    </div>
</form>

<!-- ** BEGIN: INFORMATION MESSAGE AREA ** -->
<div *ngIf="messages.length > 0">
    <span *ngFor="let msg of messages">
        {{msg}}
       
        <br />
    </span>
</div>
<!-- ** END: INFORMATION MESSAGE AREA ** -->